<section class="my-5 our-clients py-5">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12 text-center">
        <div class="section-box">
          <div class="box-title mt-5">
            <h4
              class="fs-1 text-dark"
              data-aos="fade-up"
              data-aos-duration="1000"
              [attr.data-aos-delay]="0"
              data-aos-offset="50"
              data-aos-once="true"
            >
              {{ "Clients we are proud to serve" | translate }}
            </h4>
          </div>
          <div class="box-description">
            <p
              class="fs-5 mt-5 mx-auto text-center text-dark w-75 message"
              style="line-height: 1.3"
              data-aos="fade-up"
              data-aos-duration="1000"
              [attr.data-aos-delay]="500"
              data-aos-offset="50"
              data-aos-once="true"
            >
              {{
                "A group of our customers whom we have been pleased to serve and we are still proud of what we have provided them. We show you our customers whose projects we have decorated with the finest designs and the latest software."
                  | translate
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="slider mt-2"
    data-aos="fade-up"
    data-aos-duration="1000"
    [attr.data-aos-delay]="1000"
    data-aos-offset="50"
    data-aos-once="true"
  >
    <div class="container">
      <owl-carousel-o [options]="customOptions">
        <ng-container *ngFor="let slide of data">
          <ng-template carouselSlide [id]="slide.id">
            <div
              class="image-box mx-auto d-flex justify-content-center align-items-center rounded-circle overflow-hidden"
            >
              <img
                [src]="URL + slide.photo"
                [alt]="slide.alt"
                [title]="slide.title"
                class="p-4"
              />
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</section>
